import React from 'react';
import { Link } from 'react-router-dom';
import mark from '../../assets/safehand-mark.png';
import { SITE, SOCIAL_LINKS } from '../../config/site';
import { useLang } from '../../i18n/LanguageContext';

const SOCIAL_ICONS = {
  facebook: 'fa-brands fa-facebook-f',
  instagram: 'fa-brands fa-instagram',
  linkedin: 'fa-brands fa-linkedin-in',
};

export default function Footer() {
  const { t, lang } = useLang();
  const socials = Object.entries(SOCIAL_LINKS).filter(([, url]) => url);

  return (
    <footer className="site-footer">
      <div className="container site-footer__grid">
        <div className="site-footer__brand">
          <Link to="/" className="brand">
            <img src={mark} alt="" width="40" height="40" />
            <span className="brand__text">
              <strong>SafeHand</strong>
              <small>by Safe Hand Apps</small>
            </span>
          </Link>
          <p>{t.footer.blurb}</p>
          {socials.length > 0 && (
            <div className="socials">
              {socials.map(([key, url]) => (
                <a key={key} href={url} target="_blank" rel="noopener noreferrer" aria-label={key}>
                  <i className={SOCIAL_ICONS[key]} aria-hidden="true" />
                </a>
              ))}
            </div>
          )}
        </div>

        <div>
          <h3 className="site-footer__title">{t.footer.product}</h3>
          <ul className="site-footer__list">
            <li><Link to="/safehand">{t.nav.safehand}</Link></li>
            <li><Link to="/safehand#how">{t.nav.how}</Link></li>
            <li><Link to="/safehand#partners">{t.nav.partners}</Link></li>
            <li><Link to="/faq">{t.nav.faq}</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="site-footer__title">{t.footer.company}</h3>
          <ul className="site-footer__list">
            <li><Link to="/about">{t.nav.about}</Link></li>
            <li><Link to="/services">{t.nav.studio}</Link></li>
            <li><Link to="/portfolio">{t.nav.work}</Link></li>
            <li><Link to="/contact">{t.nav.contact}</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="site-footer__title">{t.footer.contact}</h3>
          <ul className="site-footer__list site-footer__contact">
            <li>
              <i className="fa-solid fa-location-dot" aria-hidden="true" />
              <span>{SITE.address[lang]}</span>
            </li>
            <li>
              <i className="fa-solid fa-phone" aria-hidden="true" />
              <a href={`tel:${SITE.phoneIntl}`} dir="ltr">{SITE.phoneDisplay}</a>
            </li>
            {SITE.whatsapp && (
              <li>
                <i className="fa-brands fa-whatsapp" aria-hidden="true" />
                <a href={SITE.whatsapp} target="_blank" rel="noopener noreferrer">{t.contact.info.whatsapp}</a>
              </li>
            )}
            <li>
              <i className="fa-solid fa-envelope" aria-hidden="true" />
              <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container site-footer__bottom">
        <span>© {new Date().getFullYear()} {SITE.companyName}. {t.footer.rights}</span>
      </div>
    </footer>
  );
}
